import { pxToRem } from "@utils";
import styled from "styled-components";
import { baseStyle } from "../styles";

export const H3 = styled.h3`
  ${baseStyle}

  color: ${({ color, theme }) => color || theme.text.color.heading};
  font-size: ${pxToRem(17)};
  font-weight: ${({ theme }) => theme.text.weight.bold};
  line-height: ${pxToRem(24)};
  padding: 8px;
`;
